import { AxiosResponse } from 'axios'
import client from './client'

const getSupportedChain = () => async () => {
  const response = await client.request<AxiosResponse>({
    method: 'GET',
    url: `/chains`,
  })

  return response.data.data.Chains
}

const getSupportedAuditProvider = () => async () => {
  const response = await client.request<AxiosResponse>({
    method: 'GET',
    url: `/audit-partners`,
  })

  return response.data.data.partners
}
export default { getSupportedChain, getSupportedAuditProvider }
